module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/mlb/strikeout_2-7c7c581ee73cea18243474acfce29986.svg";